export default __webpack_public_path__ + "static/media/NswLandHouse.8d05d305.jpeg";